import { AuthTranslationType } from "../../features/auth.types";

export const auth: AuthTranslationType = {
  auth: {
    cookieConsent: {
      title: "Consentimiento de Cookies",
      description: "Este sitio web utiliza cookies para mejorar su experiencia de navegación. Al hacer clic en 'Aceptar', usted acepta el uso de cookies de acuerdo con nuestra Política de Cookies.",
      accept: "Aceptar Cookies",
      readMore: "Para obtener más información, lea nuestra ",
      privacyPolicy: "Política de Privacidad",
      and: "y",
      termsOfService: "Términos de Servicio"
    },
    title: {
      resetPassword: "Restablecer Contraseña",
      welcome: "Bienvenido de Nuevo"
    },
    form: {
      displayName: "Nombre de Usuario",
      email: "Correo Electrónico",
      password: "Contraseña",
      newPassword: "Nueva Contraseña",
      forgotPassword: "¿Olvidó su Contraseña?",
      loading: "Cargando...",
      signIn: "Iniciar Sesión",
      signUp: "Registrarse",
      resetPassword: "Restablecer Contraseña",
      sendResetLink: "Enviar Enlace",
      alreadyHaveAccount: "¿Ya tiene una cuenta? Iniciar Sesión",
      needAccount: "¿Necesita una cuenta? Registrarse",
      backToSignIn: "Volver a Iniciar Sesión",
      orContinueWith: "O continuar con",
      google: "Google",
      facebook: "Facebook",
      privacyPolicyAgreement: "Al hacer clic en Registrarse, usted acepta",
      privacyPolicy: "Política de Privacidad",
      termsAgreement: "y",
      termsOfService: "Términos de Servicio"
    },
    toast: {
      missingInfo: {
        title: "Información Faltante",
        description: "Por favor proporcione correo electrónico y contraseña."
      },
      missingName: {
        title: "Información Faltante",
        description: "Por favor proporcione un nombre de usuario."
      },
      invalidEmail: {
        title: "Correo Electrónico Inválido",
        description: "Por favor ingrese una dirección de correo electrónico válida."
      },
      invalidPassword: {
        title: "Contraseña Inválida",
        description: "La contraseña debe tener al menos 6 caracteres."
      },
      emailNotVerified: {
        title: "Correo No Verificado",
        description: "Por favor revise su bandeja de entrada y haga clic en el enlace de confirmación. ¿Necesita un nuevo enlace?",
        resend: "Reenviar"
      },
      verificationEmailSent: {
        title: "Correo de Verificación Enviado",
        description: "Por favor revise su bandeja de entrada para el enlace de confirmación."
      },
      loginFailed: {
        title: "Error de Inicio de Sesión",
        description: "Correo o contraseña inválidos. Por favor intente de nuevo o regístrese si no tiene una cuenta."
      },
      displayNameTaken: {
        title: "Nombre de Usuario en Uso",
        description: "Este nombre de usuario ya está en uso. Por favor elija otro."
      },
      signUpSuccess: {
        title: "Éxito",
        description: "¡Revise su correo para el enlace de confirmación!"
      },
      userAlreadyRegistered: {
        title: "Error de Registro",
        description: "Este correo ya está registrado. Por favor intente iniciar sesión."
      },
      resetEmailSent: {
        title: "Revise su correo",
        description: "Hemos enviado un enlace para restablecer su contraseña. Por favor revise su bandeja de entrada."
      },
      resetSuccess: {
        title: "Éxito",
        description: "Su contraseña ha sido restablecida con éxito. Por favor inicie sesión con su nueva contraseña."
      },
      error: {
        title: "Error",
        description: "Ha ocurrido un error inesperado. Por favor intente de nuevo."
      },
      googleLoginError: {
        title: "Error de Inicio con Google",
        description: "No se pudo iniciar sesión con Google. Por favor intente de nuevo."
      },
      facebookLoginError: {
        title: "Error de Inicio con Facebook",
        description: "No se pudo iniciar sesión con Facebook. Por favor intente de nuevo."
      },
      samePassword: {
        title: "Error",
        description: "La nueva contraseña debe ser diferente a la anterior."
      },
      agreementRequired: {
        title: "Acuerdo Requerido",
        description: "Debe aceptar la Política de Privacidad y los Términos de Servicio."
      },
    }
  }
};
